<template>
  <div>
    <Appendix
      title="Phụ lục phí giao dịch"
      :fields="fieldsTable"
      :actions="actions"
      :excepts="excepts"
      :only="only"
      :items="items"
      :contract="contract"
    >
      <!-- :_showDetails="false" -->
      <template #cellDetail="item">
        <span
          v-if="item.isDefaultFee"
          @click="showFee('Biểu phí thanh toán mặc định', item.appendixFeeTrans.feeCardAndPayment)"
          class="text-info cursor"
          >Xem phí mặc định</span
        >
        <span
          v-else
          @click="showFee('Biểu phí thanh toán đề xuất', item.appendixFeeTrans.feeCardAndPayment)"
          class="text-info cursor"
          >Xem phí đề xuất</span
        >
      </template>
      <template #file="item">
        <div v-if="item.urlPDF" class="form-detail">
          <UploadMultiple
            :lsData="[item]"
            keyUrl="urlPDF"
            :canUpload="false"
            :title="`File phụ lục ${item.code}`"
            titleTag="h1"
            titleClass="form-inner-heading"
          />
        </div>
      </template>
      <template #row-details="item">
        <feePgsAppendix
          :items="item.appendixFeeTrans.feePgs"
          :appendixFeeTrans="item.appendixFeeTrans"
        ></feePgsAppendix>
        <!-- <div class="fee-text">
        <span>Template phí:</span>
        <span>
          {{ item.appendixFeeTrans.templateFee }}
        </span>
      </div> -->
      </template>
    </Appendix>
  </div>
</template>
<script>
  import FeeTrans from './tariff-fee-trans.vue'
  import Appendix from './Appendix.vue'
  import feePgsAppendix from './feePgsAppendix.vue'
  import UploadMultiple from '@/components/UploadMultiple.vue'
  export default {
    props: {
      actions: {
        type: Function,
      },
      excepts: {
        type: Array,
        default: () => [],
      },
      only: {
        type: Array,
        default: () => [],
      },
      items: {
        type: Array,
        default: () => [],
      },
      contract: {
        type: Object,
        default: () => {},
      },
    },
    components: { Appendix, UploadMultiple, feePgsAppendix },
    data() {
      return {
        fieldsTable: [
          { key: 'code', label: 'Số phụ lục', class: 'text-left' },
          {
            key: 'time',
            label: 'Thời gian',
            class: 'text-left',
            thStyle: 'min-width: 210px',
          },
          { key: 'detail', label: 'Chi tiết', class: 'text-right' },
          { key: 'state', label: 'Trạng thái', class: 'text-center' },
          { key: 'action', label: 'Thao tác', class: 'text-center' },
        ],
      }
    },
    methods: {
      showFee(title, data) {
        this.showModalComponentMx(title, {
          name: FeeTrans,
          props: {
            data,
          },
        })
      },
    },
  }
</script>
